import styled from "@emotion/styled";
import { Stack } from "@mui/material";
import { Stack as StackIcon } from "@phosphor-icons/react";
import { Button, Notification } from "components/UI";
import { useChurchStore } from "features/churches";
import { StatInfoCard } from "features/dashboard";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useDebounce } from "react-use";
import { useAssetsPaginated } from "../api";
import {
  AddAssetModal,
  AssetsTable,
  AssetsTableHeader,
  ImportAssetsModal
} from "../components";
import { useAssetsStore } from "../store";

const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-block: 1rem 2rem;
`;

export const Assets = () => {
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const openAddAssetModal = useAssetsStore(state => state.openAddAssetModal);
  const addAssetModalOpen = useAssetsStore(state => state.addAssetModalOpen);
  const closeAddAssetModal = useAssetsStore(state => state.closeAddAssetModal);
  const openImportAssetsModal = useAssetsStore(
    state => state.openImportAssetsModal
  );
  const importAssetsModalOpen = useAssetsStore(
    state => state.importAssetsModalOpen
  );
  const closeImportAssetsModal = useAssetsStore(
    state => state.closeImportAssetsModal
  );

  const selectedChurch = useChurchStore(state => state.selectedChurch);

  const { t } = useTranslation();
  const { hash } = useLocation();

  useEffect(() => {
    if (hash === "#register-asset") {
      openAddAssetModal();
    }
  }, [hash, openAddAssetModal]);

  useDebounce(
    () => {
      setDebouncedSearch(search);
    },
    500,
    [search]
  );

  const assetsPaginatedQuery = useAssetsPaginated({
    churchId: selectedChurch?.id,
    page: 1,
    pageSize: 10,
    queries: {
      search: debouncedSearch
    }
  });

  return (
    <Stack>
      <StatGrid>
        <StatInfoCard
          title={t("Asset.Asset.TotalAsset")}
          stat={assetsPaginatedQuery.data?.result?.total_assets ?? 0}
          icon={<StackIcon size={24} />}
          color="rgba(0, 176, 185, 1)"
          background="#82DBD899"
        />
        <StatInfoCard
          title={t("Asset.Asset.TotalValueOfAsset")}
          stat={assetsPaginatedQuery.data?.result?.total_asset_value ?? 0}
          icon={<StackIcon size={24} />}
          color="rgba(0, 176, 185, 1)"
          background="#82DBD899"
        />
        <StatInfoCard
          title={t("Asset.Asset.TotalDisposed")}
          stat={assetsPaginatedQuery.data?.result?.total_disposed_assets ?? 0}
          icon={<StackIcon size={24} />}
          color="rgba(0, 176, 185, 1)"
          background="#82DBD899"
        />
      </StatGrid>
      <Stack spacing={2}>
        <Stack
          direction="row"
          alignItems="center"
          alignSelf="flex-end"
          spacing={1}
        >
          <Button onClick={openAddAssetModal}>
            {t("Asset.Asset.RegisterAsset")}
          </Button>
          <Button flavor="outlined" onClick={openImportAssetsModal}>
            {t("Asset.Asset.ImportAssets")}
          </Button>
          {/* <Button flavor="outlined" disabled>
            Export Assets
          </Button> */}
        </Stack>
        <AssetsTableHeader
          tabValue={0}
          setTabValue={() => {}}
          onSearch={setSearch}
        />
        <AssetsTable />
      </Stack>
      <AddAssetModal open={addAssetModalOpen} onClose={closeAddAssetModal} />
      <ImportAssetsModal
        open={importAssetsModalOpen}
        onClose={closeImportAssetsModal}
      />
      <Notification />
    </Stack>
  );
};
